import useListAlertsSummary from "api/queries/useListAlertsSummary";
import { Tab } from "autoGenSubTypes";
import useLastActiveTime from "./useLastActiveTime";
import useNewAlertSound from "./useNewAlertSound";

/**
 * A custom hook for playing the new alerts sound specifically for columns tabs.
 *
 */
export function useAlertsSoundForColumnsTab(tab: Tab) {
	const { lastActiveTime } = useLastActiveTime(tab);

	const columnsTabData =
		tab?.__typename === "ColumnsTab" && tab.columns_tab_data;

	const streamIdsWithSoundEnabled =
		columnsTabData ?
			columnsTabData.columns
				.map((column) =>
					column.panes
						.map((pane) => (pane.sound.enabled ? pane.streamIds : []))
						.flat()
				)
				.flat()
		:	[];

	const alertsParams = {
		backfill: true,
		count: 1,
		after: new Date(lastActiveTime).toISOString(),
		stream_ids: streamIdsWithSoundEnabled,
	};
	const { data: alerts } = useListAlertsSummary(alertsParams, {
		refetchIntervalInBackground: true,
	});

	const totalMissedAlerts = alerts?.length ?? 0;

	useNewAlertSound({
		enabled: streamIdsWithSoundEnabled.length > 0,
		newAlertCount: totalMissedAlerts,
	});
}
